/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Fonts_Add_Font_TitleInputs */

const en_options_fonts_add_font_title = /** @type {(inputs: Options_Fonts_Add_Font_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Font`)
};

const fr_options_fonts_add_font_title = /** @type {(inputs: Options_Fonts_Add_Font_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter une police`)
};

const de_options_fonts_add_font_title = /** @type {(inputs: Options_Fonts_Add_Font_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schriftart hinzufügen`)
};

const it_options_fonts_add_font_title = /** @type {(inputs: Options_Fonts_Add_Font_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi carattere`)
};

const ru_options_fonts_add_font_title = /** @type {(inputs: Options_Fonts_Add_Font_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить шрифт`)
};

const es_options_fonts_add_font_title = /** @type {(inputs: Options_Fonts_Add_Font_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar fuente`)
};

const zh_cn2_options_fonts_add_font_title = /** @type {(inputs: Options_Fonts_Add_Font_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加字体`)
};

const ja_options_fonts_add_font_title = /** @type {(inputs: Options_Fonts_Add_Font_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォントを追加`)
};

const hi_options_fonts_add_font_title = /** @type {(inputs: Options_Fonts_Add_Font_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ॉन्ट जोड़ें`)
};

const pt_pt2_options_fonts_add_font_title = /** @type {(inputs: Options_Fonts_Add_Font_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar fonte`)
};

/**
* | output |
* | --- |
* | "Add Font" |
*
* @param {Options_Fonts_Add_Font_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_fonts_add_font_title = /** @type {((inputs?: Options_Fonts_Add_Font_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Fonts_Add_Font_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_fonts_add_font_title(inputs)
	if (locale === "de") return de_options_fonts_add_font_title(inputs)
	if (locale === "it") return it_options_fonts_add_font_title(inputs)
	if (locale === "ru") return ru_options_fonts_add_font_title(inputs)
	if (locale === "es") return es_options_fonts_add_font_title(inputs)
	if (locale === "zh-CN") return zh_cn2_options_fonts_add_font_title(inputs)
	if (locale === "ja") return ja_options_fonts_add_font_title(inputs)
	if (locale === "hi") return hi_options_fonts_add_font_title(inputs)
	if (locale === "pt-PT") return pt_pt2_options_fonts_add_font_title(inputs)
	return en_options_fonts_add_font_title(inputs)
});